import { ChangeEvent, FormEvent, memo, useState } from 'react';
import { transferToBotAtom, useValue } from '@/store';
import {
  Backdrop,
  Card,
  CloseButton,
  CloseIcon,
  EmailInput,
  Form,
  Heading,
  SubmitButton,
  Text,
} from './SamTransferModal.styles';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

interface SamTransferModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SamTransferModal = memo<SamTransferModalProps>(({ isOpen, onClose }) => {
  const transferToBot = useValue(transferToBotAtom);
  const [email, setEmail] = useState('');
  const [isInvalid, setIsInvalid] = useState(false);

  const handleDismiss = () => {
    transferToBot?.(undefined);
    onClose();
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (email && !EMAIL_REGEX.test(email)) {
      setIsInvalid(true);
      return;
    }
    transferToBot?.(email ?? undefined);
    onClose();
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (isInvalid) {
      setIsInvalid(false);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Backdrop onClick={handleDismiss}>
      <Card onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={handleDismiss} data-testid="sam-transfer-modal-close">
          <CloseIcon />
        </CloseButton>
        <Heading>Still need help?</Heading>
        <Text>Please leave us your email address and our customer service team will get back to you:</Text>
        <Form onSubmit={handleSubmit}>
          <EmailInput
            type="text"
            value={email}
            onChange={handleChange}
            isInvalid={isInvalid}
            placeholder="your@email.com"
            data-testid="sam-transfer-modal-email"
          />
          <SubmitButton
            type="submit"
            data-testid="sam-transfer-modal-submit"
            disabled={!email || !EMAIL_REGEX.test(email)}
          >
            Send
          </SubmitButton>
        </Form>
      </Card>
    </Backdrop>
  );
});
